import React from "react";
import lodash from "lodash";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

export function usePostRegistrations(token, requestBody, patch = false, id = undefined) {
  const [body, setBody] = React.useState();
  const [response, setResponse] = React.useState();
  const [error, setError] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);

  /**
   * Compair requestBody to body so we don't infinant loop
   */
  React.useEffect(() => {
    if (!lodash.isEqual(requestBody, body)) {
      setError(undefined);
      setResponse(undefined);
      setBody(requestBody);
      setIsLoading(true);
    }
  }, [requestBody, setBody]);

  /**
   * Make Request
   */
  React.useEffect(() => {
    if (token && body) {
      const options = {
        method: patch ? "PATCH" : "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: body }),
      };

      options.body = patch ? JSON.stringify({ user: body }) : JSON.stringify({ data: body });
      const path = patch ? `${PATHS.apiRegistration}/${id}` : `${PATHS.apiRegistration}`;

      async function patchRequest() {
        const request = await fetch(path, options);
        return request.json();
      }

      patchRequest()
        .then((data) => {
          if (data) setResponse(data);
          else setError("unknown-error");
          setIsLoading(false);
        })
        .catch((_error) => {
          setError(_error);
          setIsLoading(false);
        });
    }
  }, [token, body, setResponse]);

  return { postUser: response, postUserError: error, postUserIsLoading: isLoading };
}
